<template>
    <div class="wangEditor text-editor" id="wangEditor"  v-loading="loading"></div>
</template>
<script>
import E from 'wangeditor'

export default {
  props: ['setEditorValue', 'content'],
  data () {
    return {
      editor: null,
      baseURL: this.baseUrl,
      loading: false
    }
  },
  mounted () {
    this.initEditor()
  },
  watch: {
    content (val) {
      console.log(val)
      if (this.editor) {
        this.editor.txt.html(val)
      }
    }
  },
  methods: {
    /**
             * @description 初始化富文本编辑器
             */
    initEditor () {
      let _this = this
      this.editor = new E('#wangEditor')
      this.editor.config.height = 200
      // 设置z-index
      this.editor.config.zIndex = 1
      // 限制上传大小
      this.editor.config.uploadImgMaxSize = 500 * 1024 * 1024
      // 限制上传张数
      this.editor.config.uploadImgMaxLength = 10
      // 不过滤复制的图片
      this.editor.config.pasteIgnoreImg = false
      // 关闭复制的样式过滤
      this.editor.config.pasteFilterStyle = false
      this.editor.config.menus = [
        // 'head', // 标题
        // 'bold', // 粗体
        // 'fontSize', // 字号
        // 'italic', // 斜体
        // 'underline', // 下划线
        // 'strikeThrough', // 删除线
        // 'foreColor', // 文字颜色
        // // 'link', // 插入链接
        // 'list', // 列表
        // 'justify', // 对齐方式
        // // 'quote', // 引用
        // 'image', // 插入图片
        // // 'code', // 插入代码
        // 'undo', // 撤销
        // 'redo' // 重复
        // 'fullscreen' // 全屏
      ]
      // 设置上传路径
      this.editor.config.uploadImgServer = _this.baseURL + '/upload'
      this.editor.config.uploadFileName = 'file'
      this.editor.config.uploadImgHooks = {
        customInsert: function (insertImg, result, editor) {
          _this.loading = true
          if (result.code === '200') {
            insertImg(result.msg)
            _this.$message.success('上传图片成功')
            _this.loading = false
          } else {
            _this.$message.error('富文本图片上传失败')
            _this.loading = false
          }
        }
      }
      // 自定义提示信息
      this.editor.config.customAlert = function (info) {
        _this.$message.error(info)
      }
      this.editor.config.onchange = function (html) {
        _this.$emit('setHtml', html)
      }
      this.editor.create()
    }
  }
}
</script>
<style lang="less" scoped>
.text-editor .w-e-toolbar{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editor2.vue